export default __webpack_public_path__ + "static/media/news-management-icon.4206008d.svg";